import { Inventory } from "./inventory";

export enum SeparationStatus {
  notSeparated = "NOT_SEPARATED",
  separated = "SEPARATED",
}

export interface InventoryReservation {
  id?: number;
  cargoItemId?: number;
  amount: number;
  inventory: Inventory;
  status: SeparationStatus;
}
